import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { Ong } from "../../../utils/entities/Ong";

interface DireccionProps {
  ong: Ong;
}

function Direccion(props: DireccionProps) {
  const sedePrincipal = props.ong.sedes[0];

  return (
    <div className="direccion">
      <div className="subtitulo">Dirección</div>
      <div className="direccion-container">
        <div className="icon">
          <FontAwesomeIcon icon={faLocationDot} />
        </div>
        <div className="data">
          <div>{sedePrincipal?.description}</div>
          <div>Horarios: {sedePrincipal?.time}</div>
        </div>
      </div>
    </div>
  );
}
export default Direccion;
